import React from "react";
import { Collapse } from "antd";
import { useCanvas } from "../../context/canvasContext";
import './antSidebar.css';
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const { Panel } = Collapse;

const StickyNotesModal = ({ isStickyNotesModalVisible, setIsStickyNotesModalVisible }) => {
  const isMobile = window.screen.width < 768;

  const { id } = useParams();
  const { createStickyNote } = useCanvas();

  const stickyNoteColors = [
    { name: "Yellow", color: "#FFEB3B" },
    { name: "Pink", color: "#F06292" },
    { name: "Blue", color: "#64B5F6" },
    { name: "Green", color: "#81C784" },
    { name: "Orange", color: "#FFB74D" },
  ];

  const handleStickyNoteCreate = (color) => {
    createStickyNote(id,{
      width: 200,
      height: 150,
      backgroundColor: color,
      left: 100,
      top: 100,
      fontSize: 16,
    });
    setIsStickyNotesModalVisible(false);
  };

  if (!isStickyNotesModalVisible) {
    return null;
  }

  const handleCollapseChange = (key) => {
    if (key.length === 0) {
      setIsStickyNotesModalVisible(false);
    }
  };

  return (
    <div style={{
      width: isMobile ? '155px' : '168px',
      position: isMobile ? 'absolute' : '',
      top: isMobile ? '-290px' : '',
      right: isMobile ? "40px" : '',
      boxShadow: "rgb(101 92 92 / 50%) 0px 3px 8px",
      borderRadius: "5px",
    }}>
      <Collapse
        bordered={true}
        expandIconPosition="right"
        defaultActiveKey={['1']}
        onChange={handleCollapseChange}
      >
        <Panel
          style={{ fontSize: isMobile ? '11px' : '13px' }}
          header="Sticky Notes"
          key="1"
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', cursor: 'pointer' }}>
            {stickyNoteColors.map((note) => (
              <div
                key={note.name}
                onClick={() => handleStickyNoteCreate(note.color)}
                style={{
                  padding: '10px',
                  backgroundColor: note.color,
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  textAlign: 'center',
                  color: '#333',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                {note.name}
              </div>
            ))}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default StickyNotesModal;
